import React from 'react'
import { Card, CardHeader, CardTitle, CardBody } from 'reactstrap'

const Documents = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle tag='h4'>Progress Assessment Documents</CardTitle>
      </CardHeader>
      <CardBody>
        <div className='documents-container'>
          {/* Add your documents content here */}
          <p>Progress assessment documents will be displayed here.</p>
        </div>
      </CardBody>
    </Card>
  )
}

export default Documents 